import { computed, ComputedRef } from "vue";
import { injectDisplayEvents } from "../composition/displayEvents";
import { useTemplateSize } from "@fresh8/ad-data-composition/src/useTemplateSize";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { enabledParlaySizes } from "@fresh8/types/src/featureFlags";

export function useParalyCardDisplayState(): {
  parlayIncluded: ComputedRef<boolean>;
} {
  const parlayIncluded = computed(() => {
    const { size } = useTemplateSize();
    const brand = injectBrand();
    const events = injectDisplayEvents();

    const isEnabledSize = enabledParlaySizes.includes(size.value.name);

    return !!(
      isEnabledSize &&
      (brand?.adTemplate.value?.eventCardOrder || []).indexOf("parlay") > -1 &&
      events?.parlayMarkets.value?.length === 3
    );
  });

  return {
    parlayIncluded
  };
}
